import { useContext } from "react";
import { Button } from "../Button";
import { ThemeContext } from "../context";
import {
  FormController,
  StyledTextInput,
  StyledForm,
  StyledSelect,
  SelectInput,
  Error,
} from "./Form.elements";
import { AiFillCaretDown } from "react-icons/ai";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useWaitListMutation } from "../../app/services/auth";
import { Loader } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { WaitListResponse } from "../../app/services/declarations";

export const Form = ({
  entries,
  formbg,
  formcolor,
  buttonText,
  icon,
  paddingvals,
  isflex,
  formWidthButton,
  opacity,
}: any) => {
  const { rooTheme } = useContext(ThemeContext);

  const [waitList, { isLoading }] = useWaitListMutation();

  const formik = useFormik({
    initialValues: {
      type: "",
      email: "",
    },
    validationSchema: Yup.object({
      type: Yup.string().required("Please, select type"),
      email: Yup.string().email("Invalid email").required("Required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const result = await waitList({
          email: values?.email,
          accountType: values?.type,
        }).unwrap();
        await notifications.show({
          title: "Jiffy Waitlist",
          message: `${result?.message} 😊`,
          styles: () => ({
            root: {
              backgroundColor: "rgba(78, 207, 78, 1)",
              borderColor: "rgba(78, 207, 78, 1)",
              "&::before": { backgroundColor: "#fff" },
            },

            title: { color: "#fff" },
            description: { color: "#fff" },
            closeButton: {
              color: "#fff",
              "&:hover": { backgroundColor: "rgba(78, 207, 78, 0.2)" },
            },
          }),
        });
        const initialValues = {
          type: "",
          email: "",
        };
        resetForm({ values: initialValues });
      } catch (error: any) {
        const { data } = error;
        await notifications.show({
          title: "Jiffy Waitlist",
          message: `${data?.message} 😔`,
          styles: () => ({
            root: {
              backgroundColor: "rgba(233, 72, 72, 1)",
              borderColor: "rgba(233, 72, 72, 1)",
              "&::before": { backgroundColor: "#fff" },
            },

            title: { color: "#fff" },
            description: { color: "#fff" },
            closeButton: {
              color: "#fff",
              "&:hover": { backgroundColor: "rgba(233, 72, 72, 0.2)" },
            },
          }),
        });
      }
    },
  });

  return (
    <FormController>
      {entries?.map((entry: any) => {
        return (
          <div key={entry.id}>
            <StyledForm onSubmit={formik.handleSubmit} isflex={isflex}>
              <div className={""}>
                <SelectInput
                  theme={rooTheme}
                  formbg={formbg}
                  opacity={opacity}
                  formcolor={formcolor}
                  isflex={isflex}
                >
                  <StyledSelect
                    data={[
                      { value: "INDIVIDUAL", label: "Individual (you)" },
                      { value: "CORPORATE", label: "Corporate (SMEs)" },
                      { value: "COURIER", label: "Courier" },
                    ]}
                    placeholder={entry.typePlaceholder}
                    id="type"
                    onChange={(option) => {
                      formik.setFieldValue("type", option);
                    }}
                    theme={rooTheme}
                    formbg={formbg}
                    opacity={opacity}
                    formcolor={formcolor}
                    isflex={isflex}
                    rightSection={
                      <AiFillCaretDown
                        size="1rem"
                        color={
                          rooTheme === "dark"
                            ? "rgba(255, 255, 255, 0.5)"
                            : "rgba(30, 30, 30, 0.3)"
                        }
                      />
                    }
                  />
                  <StyledTextInput
                    placeholder={entry.placeholder}
                    {...formik.getFieldProps("email")}
                    id="email"
                    theme={rooTheme}
                    formbg={formbg}
                    opacity={opacity}
                    formcolor={formcolor}
                    isflex={isflex}
                  />
                  <div className="flex justify-start">
                    {formik.touched.email && formik.errors.email ? (
                      <Error>{formik.errors.email}</Error>
                    ) : null}
                  </div>
                </SelectInput>
              </div>

              <Button
                children={buttonText || "Join Waitlist"}
                isfull={true}
                background="#007FFF"
                color="#fff"
                icon={isLoading ? <Loader variant="dots" color="#fff" /> : icon}
                type="submit"
                ispadding={true}
                paddingvals={paddingvals || "18px 30px"}
                formWidthButton={formWidthButton}
              />
            </StyledForm>
          </div>
        );
      })}
    </FormController>
  );
};
